import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Holds various device state, such as media size.
 */
import { MEDIA_QUERY_DEFAULTS, BREAKPOINT_BY_SCREEN_TYPE, SCREEN_TYPES } from 'constants/media-queries';
var SET_MEDIA_STATE = 'classpass/device/SET_MEDIA_STATE';
export var SET_IS_CLIENT = 'classpass/device/SET_IS_CLIENT';
export var setMediaState = function setMediaState(mediaState) {
  return {
    type: SET_MEDIA_STATE,
    data: {
      key: 'media',
      val: mediaState
    }
  };
};
export var setIsClient = function setIsClient(isClient) {
  return {
    type: SET_IS_CLIENT,
    data: {
      key: 'isClient',
      val: isClient
    }
  };
};
export var selectMediaState = function selectMediaState(state) {
  return state.device.media;
};
export var selectIsMobile = function selectIsMobile(state) {
  return !state.device.media.md;
};
export var selectIsClient = function selectIsClient(state) {
  return state.device.isClient;
};
export var matchesScreenType = function matchesScreenType(screenType, state) {
  var mediaState = selectMediaState(state) || {};
  return !!mediaState[BREAKPOINT_BY_SCREEN_TYPE[screenType]];
};
export var detectScreenType = function detectScreenType(state) {
  var matchesTablet = matchesScreenType(SCREEN_TYPES.tablet, state);
  var matchesDesktop = matchesScreenType(SCREEN_TYPES.desktop, state);
  return matchesDesktop && 'desktop' || matchesTablet && 'tablet' || 'phone';
};

var getInitialState = function getInitialState() {
  return {
    media: MEDIA_QUERY_DEFAULTS,
    isClient: false
  };
};

export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_MEDIA_STATE:
    case SET_IS_CLIENT:
      return _objectSpread({}, state, _defineProperty({}, action.data.key, action.data.val));

    default:
      return state;
  }
}